import React, { useState, useEffect, useRef } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { API_BASE_URL } from "../config";

const PartnerRegistration = () => {

  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    business_type: "",
    tin: "",
    businessAddress: "",
    deliveryAddress:"", // ✅ Fixed casing
    companyWebsite: "", // ✅ Fixed casing
    license: null,
    companyLogo: null,
    partnership_type: "",
    business_compensation: "",
    password: "",
    country:"",
  });

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    let errors = {};

    if (!formData.name) errors.name = "Company Name is required";
    if (!formData.customername) errors.customername = "Customer Name is required";
    if (!formData.mobile) errors.mobile = "Contact number is required";
    if (!formData.email) errors.email = "Email is required";
    
    // if (!formData.business_type) errors.business_type = "Business type is required";
    // if (!formData.tin) errors.tin = "Tax ID (TIN) is required";
    // if (!formData.businessAddress) errors.businessAddress = "Company Address is required";
    // if (!formData.license) errors.license = "Company Profile is required";
    // if (!formData.companyLogo) errors.companyLogo = "Company Logo is required"; // ✅ Fixed casing
    // if (!formData.companyWebsite) errors.companyWebsite = "Company Website is required"; // ✅ Fixed casing    
    // if (!formData.partnership_type) errors.partnership_type = "Partnership Type is required";
    // if (!formData.business_compensation) errors.business_compensation = "Compensation is required";
    //if (!formData.password) errors.password = "Password is required";

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };


  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    setFormData({
      ...formData,
      [name]: type === "file" ? files[0] : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("test1");

    if (!validateForm()) return;

    console.log("test");

    const formDataToSend = new FormData();

    const jsonFormData = JSON.stringify({
      CompanyName: formData.name,
      DeliveryAddress:formData.customername,
      Mobile: formData.mobile,
      Email: formData.email,
      Password: "Web@#123",//formData.password,
      BusinessType: "wholesaler",//formData.business_type,
      TaxId: "",//formData.tin,
      BusinessAddress:formData.businessAddress, // ✅ Fixed casing
      CompanyWebsite: formData.CompanyWebsite, // ✅ Fixed casing      
      PartnershipType: "Both",//formData.partnership_type,
      BusinessCompensation: "",//formData.business_compensation,
      CreatedBy: "website", // Set this dynamically
      IsActive: false,
      IsDeleted: false,
      Country:formData.country,
    });

    formDataToSend.append("modelJson", jsonFormData);

    if (formData.license) {
      formDataToSend.append("License", formData.license);
    }

    if (formData.companyLogo) {
      formDataToSend.append("CompanyLogo", formData.companyLogo); // ✅ Fixed casing
    }

    try {
      console.log("Received JSON Data: " + formData);
      const response = await fetch(`${API_BASE_URL}/Home/InsertUpdateCompany`, {
        method: "POST",
        body: formDataToSend,
      });

      const responseData = await response.json();
      console.log("API Response:", responseData);

      if (response.ok) {
        alert("Form submitted successfully!");

        setFormData({
          name: "",
          mobile: "",
          email: "",
          business_type: "",
          tin: "",
          businessAddress: "",
          deliveryAddress:"",
          companyWebsite: "",
          license: null,
          companyLogo: null,
          partnership_type: "",
          business_compensation: "",
          password: "",
          country:"",
        });


        setErrors({});
      } else {
        console.error("Error submitting form:", responseData);
        alert(`Error: ${responseData.message || "Unknown error"}`);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Something went wrong. Please try again.");
    }
  };


  return (
    <div>

      <div id="site-main" className="site-main">
        <Header />
        <br />
        <div id="main-content" className="main-content">

          <div id="primary" className="content-area">

            <div id="content" className="site-content" role="main">
              <div className="section-padding">
                <div className="section-container p-l-r">
                  <div className="page-login-register" style={{ paddingBottom: 100 }}>
                    <div className="row justify-content-center">
                      <div className="col-lg-6 col-md-12 col-sm-12 sm-m-b-50">
                        <div className="box-form-login">
                          <h2>Customer Registration</h2>
                          <div className="box-content">
                            <div className="form-login">
                              <form onSubmit={handleSubmit} className="login">
                                <div className="row col-lg-12">
                                  <div className="col-md-12">
                                    <label>
                                      Company Name <span className="required">*</span>
                                    </label>
                                    <input type="text" name="name" value={formData.name} onChange={handleChange} />
                                    {errors.name && <span className="error">{errors.name}</span>}
                                  </div>
  <div className="col-md-12">
                                    <label>
                                      Customer Name <span className="required">*</span>
                                    </label>
                                    <input type="text" name="customername" value={formData.customername} onChange={handleChange} />
                                    {errors.customername && <span className="error">{errors.customername}</span>}
                                  </div>
                                  <div className="col-md-6">
                                    <label>
                                      Company Contact Number <span className="required">*</span>
                                    </label>
                                    <input type="number" name="mobile" value={formData.mobile} onChange={handleChange} />
                                    {errors.mobile && <span className="error">{errors.mobile}</span>}
                                  </div>

                                  <div className="col-md-6">
                                    <label>
                                      Company Email Address <span className="required">*</span>
                                    </label>
                                    <input type="email" name="email" value={formData.email} onChange={handleChange} />
                                    {errors.email && <span className="error">{errors.email}</span>}
                                  </div>
                                  <div className="col-md-12">
                                    <label>
                                      Company Address <span className="required">*</span>
                                    </label>
                                    <input type="text" name="businessAddress" value={formData.businessAddress} onChange={handleChange} />
                                    {/* {errors.businessAddress && <span className="error">{errors.businessAddress}</span>} */}
                                  </div>

                                  <br></br>




                                  {/* <div className="col-md-6">
        <label>Company Profile</label>
        <input type="file" name="license" onChange={handleChange} />
        {errors.license && <span className="error">{errors.license}</span>}
      </div>

      <div className="col-md-6">
        <label>
          Company Logo <span className="required">*</span>
        </label>
        <input type="file" name="companyLogo" onChange={handleChange} />
        {errors.companyLogo && <span className="error">{errors.companyLogo}</span>}
      </div> */}

                                  <div className="col-md-8">
                                    <label>
                                      Company Website <span className="required">*</span>
                                    </label>
                                    <input type="text" name="companyWebsite" value={formData.companyWebsite} onChange={handleChange} />
                                  </div>

                                  <div className="col-md-4">
                                    <label>
                                      Country <span className="required">*</span>
                                    </label>
                                    <select className="form-control" id="country" name="country" value={formData.country} onChange={handleChange}>
                                      <option value="">Select Country</option>                                     
                                      <option value="US">United States</option>
                                      <option value="AU">Australia</option>
                                      <option value="EU">European Union</option>
                                      <option value="GB">United Kingdom</option>
                                      <option value="AE">United Arab Emirates</option>
                                      <option value="DE">Germany</option>
                                      <option value="FR">France</option>
                                      <option value="JP">Japan</option>
                                    </select>
                                  </div>
                                  {/* <div className="col-md-6">
        <label>
          Password <span className="required">*</span>
        </label>
        <input type="password" name="password" value={formData.password} onChange={handleChange} />
        {errors.password && <span className="error">{errors.password}</span>}
      </div>
      <div className="col-md-6">
        <label>
          Tax ID (TIN) <span className="required">*</span>
        </label>
        <input type="number" name="tin" value={formData.tin} onChange={handleChange} />
        
      </div>
     <div className="col-md-6">
        <label>Business Type</label>
        <select name="business_type" value={formData.business_type} onChange={handleChange}>
          <option value="" disabled>
            Select your business type
          </option>
          <option value="retailer">Retailer</option>
          <option value="wholesaler">Wholesaler</option>
          <option value="designer">Designer</option>
          <option value="other">Other</option>
        </select>
      </div>
      <div className="col-md-6">
        <label>Preferred Partnership Type : </label>
        <select name="partnership_type" value={formData.partnership_type} onChange={handleChange}>
          <option value="" disabled>
            Select partnership type
          </option>
          <option value="supplier">Supplier</option>
          <option value="distributor">Distributor</option>
          <option value="marketing">Marketing Partner</option>
        </select>
      </div> */}

                                  {/* <div className="col-md-6">
        <label>Business Compensation : </label>
        <select name="business_compensation" value={formData.business_compensation} onChange={handleChange}>
          <option value="" disabled>
            Select your compensation
          </option>
          <option value="10%">10%</option>
          <option value="20%">20%</option>
          <option value="30%">30%</option>
          <option value="40%">40%</option>
        </select>
      </div> */}


                                </div>
                                <br />

                                <div className="button-login">
                                  <input type="submit" className="button" value="Submit" />
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <Footer />
        </div>

      </div>

    </div>

  );


};
export default PartnerRegistration